<template>
  <div class="list flex flex_wrap">
    <!-- type 1 会议日程 2 线上课程 3 活动-->
    <div
      class="item"
      v-for="(item, index) in list"
      :key="index"
      @click="toDetails(item)"
    >
      <template v-if="type == 1">
        <div class="img-wrap flex flex_content_center flex_items_center">
          <el-image
            v-if="item.img"
            class="img"
            :src="item.img"
            :fit="'cover'"
          ></el-image>
          <img class="img" v-else src="../assets/kv.jpg" alt="" />
        </div>
        <div class="title">
          {{ langSet == "cn" ? item.title : item.en_title }}
        </div>
        <div style="margin-bottom: 5px">{{ langSet == "cn" ? "时间" : "Time" }}：{{ item.starttime }}</div>
        <div style="width: 75%">{{ langSet == "cn" ? "地点" : "Location" }}：{{ item.address }}</div>
        <div class="enter">
          {{ langSet == "cn" ? "前往报名" : "Register Now" }}
        </div>
      </template>
      <template v-if="type == 2">
        <div class="img-wrap flex flex_content_center flex_items_center">
          <el-image
            v-if="item.img"
            class="img"
            :src="item.img"
            :fit="'cover'"
          ></el-image>
          <img class="img" v-else src="../assets/kv.jpg" alt="" />
        </div>
        <div class="title">
          {{ langSet == "cn" ? item.title : item.en_title }}
        </div>
        <div style="margin-bottom: 5px">{{ langSet == "cn" ? "时间" : "Time" }}：{{ item.starttime }}</div>
        <div>{{ langSet == "cn" ? "课程导师" : "Course Tutor" }}：{{ item.teacher_name }}</div>
        <div class="enter">{{ langSet == "cn" ? "点击进入" : "Details" }}</div>
      </template>
      <template v-if="type == 3">
        <div class="img-wrap flex flex_content_center flex_items_center">
          <el-image
            v-if="item.thumb"
            class="img"
            :src="item.thumb"
            :fit="'cover'"
          ></el-image>
          <img class="img" v-else src="../assets/kv.jpg" alt="" />
        </div>
        <div class="title">
          {{ langSet == "cn" ? item.title : item.en_title }}
        </div>
        <div style="margin-bottom: 5px">{{ item.start_time }}</div>
        <div>{{ langSet == "cn" ? item.address : item.en_address }}</div>
        <!-- <div class="enter">
          {{ langSet == "cn" ? "前往报名" : "Register Now" }}
        </div> -->
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    type: String,
    external: String,
  },
  data() {
    return {
      langSet: "",
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    //25.9.16 跳转详情 dxm
    toDetails(e) {
      if (this.type == 1 || this.type == 3) {
        this.$router.push({
          path: "/courseDetails",
          query: {
            id: this.external == "active" ? e.activity_id : e.id,
            type: this.type,
          },
        });
      } else {
        if (e.web_url) {
          window.open(e.web_url, "_blank");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  .item {
    width: calc(100% / 3 - 21px);
    padding: 15px;
    font-size: 14px;
    color: #757575;
    line-height: 20px;
    border-radius: 20px;
    cursor: pointer;
    margin: 0 31px 20px 0;
    background: #f7f8fa;
    box-sizing: border-box;
    border: 1px solid #f7f8fa;
    position: relative;
    transition: all 0.5s ease-in-out;
    &:hover {
      background: #e9eaf2;
      .enter {
        color: #fff;
        background: #1d2379;
      }
    }
    .title {
      font-size: 16px;
      color: #001a33;
      line-height: 22px;
      padding-bottom: 10px;
      width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .img-wrap {
      width: 100%;
      height: 208px;
      border-radius: 12px;
      margin-bottom: 15px;
      background: #fff;
      overflow: hidden;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .enter {
      position: absolute;
      bottom: 16px;
      right: 15px;
      min-width: 86px;
      height: 28px;
      padding: 0 10px;
      box-sizing: border-box;
      font-size: 14px;
      color: #1d2379;
      text-align: center;
      line-height: 28px;
      background: transparent;
      border-radius: 14px;
      transition: all 0.5s ease-in-out;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .list .item {
    width: calc(100% / 3 - 10px);
    margin-right: 15px;
  }
}
@media only screen and (max-width: 767px) {
  .list .item {
    width: 100%;
    padding: 0.19rem;
    margin-right: 0;
    font-size: 0.27rem;
    line-height: 0.38rem;
    .img-wrap {
      height: 3.58rem;
      margin-bottom: 0.29rem;
    }
    .title {
      font-size: 0.31rem;
      line-height: 0.42rem;
    }
    .enter {
      width: 1.65rem;
      height: 0.54rem;
      color: #fff;
      font-size: 0.23rem;
      background: #1d2379;
    }
  }
}
</style>